import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { SummaryRow, TransactionRow } from "namirasoft-balance";
import { IStorageLocal } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, MoneyFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { BalanceRouterProps } from "./BalanceRouterProps";
import { BalanceRoutes } from "./BalanceRoutes";

export class BalanceEntities
{
	static product_id = ProductUUID.NAMIRASOFT_BALANCE;

	static summary(props: NSARouterMakerResult & BalanceRouterProps, asset_id: string): IEntityInfo<SummaryRow, SummaryRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: BalanceEntities.product_id,
			name: "summary",
			tables: [{ table: namirasoft.balance.tables.summary, required: true }],
			client: {
				getListURL: () => BalanceRoutes.SummaryList(asset_id),
				getViewURL: (id: string) => BalanceRoutes.SummaryView(id),
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.party_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.asset_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.year, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.month, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.previous_balance, new MoneyFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.total_debt, new MoneyFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.total_credit, new MoneyFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.final_balance, new MoneyFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.summary.columns.updated_at, new DateTimeFormatter()),
					];
				},
			},
			server: {
				value_list: props.servers.balance.value.List,
				list: (filters, page, size, sorts) =>
				{
					return props.servers.balance.summary.List(asset_id, filters, page, size, sorts, null);
				},
				get: props.servers.balance.summary.Get,
				create: null,
				update: null,
				delete: null,
			}
		};
	}
	static transaction(props: NSARouterMakerResult & BalanceRouterProps, asset_id: string): IEntityInfo<TransactionRow, TransactionRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: BalanceEntities.product_id,
			name: "transaction",
			tables: [{ table: namirasoft.balance.tables.transaction, required: true }],
			client: {
				getListURL: () => BalanceRoutes.TransactionList(asset_id),
				getViewURL: (id: string) => BalanceRoutes.TransactionView(id),
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.journal_entry_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.account_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.party_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.txn_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.description, new StringFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.amount, new MoneyFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.balance.tables.transaction.columns.updated_at, new DateTimeFormatter()),
					];
				},
			},
			server: {
				value_list: props.servers.balance.value.List,
				list: (filters, page, size, sorts) =>
				{
					return props.servers.balance.transaction.List(asset_id, filters, page, size, sorts, null);
				},
				get: props.servers.balance.transaction.Get,
				create: null,
				update: null,
				delete: null,
			}
		};
	}
}